import CRUDService from '@/services/hrsg/CRUDService';

export class ResultAccessService extends CRUDService {
  constructor () {
    super('reviews.result-accesses');
  }
}

export default new ResultAccessService();
